import React from 'react';
import { checkSupabaseConfig } from '../lib/supabase';

const ConfigNotice: React.FC = () => {
  if (checkSupabaseConfig()) {
    return null;
  }

  return (
    <div style={{
      position: 'fixed',
      top: '10px',
      right: '10px',
      background: '#fff3cd',
      border: '1px solid #ffeaa7',
      borderRadius: '8px',
      padding: '12px 16px',
      maxWidth: '300px',
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      zIndex: 1000,
      fontSize: '14px'
    }}>
      <div style={{ fontWeight: 'bold', marginBottom: '8px', color: '#856404' }}>
        ⚠️ 演示模式
      </div>
      <div style={{ color: '#856404', marginBottom: '8px' }}>
        当前使用模拟数据。要使用真实数据，请：
      </div>
      <ol style={{
        margin: '0',
        paddingLeft: '16px',
        color: '#856404',
        fontSize: '12px'
      }}>
        <li>创建 Supabase 项目</li>
        <li>配置环境变量</li>
        <li>运行数据库脚本</li>
      </ol>
      <div style={{
        marginTop: '8px',
        fontSize: '12px',
        color: '#666',
        fontStyle: 'italic'
      }}>
        登录测试账号：demo / demo
      </div>
    </div>
  );
};

export default ConfigNotice; 